var _path, _circle, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMemberMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.79885 17.9895L2.18599 17.7729L2.79885 17.9895ZM4.3301 19.5207L4.11354 18.9079H4.11353L4.3301 19.5207ZM6.3184 18.8182L6.53496 19.431L6.3184 18.8182ZM7.18435 18.8997L7.49649 18.3296L7.18435 18.8997ZM3.47009 15.0688L4.04966 14.7746L3.47009 15.0688ZM3.53532 15.9053L4.14818 16.1219L3.53532 15.9053ZM3.15 11C3.15 6.38842 6.88842 2.65 11.5 2.65V1.35C6.17045 1.35 1.85 5.67045 1.85 11H3.15ZM4.04966 14.7746C3.47449 13.6417 3.15 12.3597 3.15 11H1.85C1.85 12.5688 2.22487 14.052 2.89051 15.3631L4.04966 14.7746ZM3.41172 18.2061L4.14818 16.1219L2.92245 15.6888L2.18599 17.7729L3.41172 18.2061ZM4.11353 18.9079C3.6776 19.0619 3.25767 18.642 3.41172 18.2061L2.18599 17.7729C1.66785 19.2393 3.08032 20.6517 4.54666 20.1336L4.11353 18.9079ZM6.10184 18.2053L4.11354 18.9079L4.54666 20.1336L6.53496 19.431L6.10184 18.2053ZM11.5 19.35C10.0481 19.35 8.6845 18.98 7.49649 18.3296L6.87222 19.4699C8.24679 20.2224 9.82443 20.65 11.5 20.65V19.35ZM19.85 11C19.85 15.6116 16.1116 19.35 11.5 19.35V20.65C16.8295 20.65 21.15 16.3295 21.15 11H19.85ZM11.5 2.65C16.1116 2.65 19.85 6.38842 19.85 11H21.15C21.15 5.67045 16.8295 1.35 11.5 1.35V2.65ZM6.53496 19.431C6.6293 19.3977 6.75197 19.404 6.87222 19.4699L7.49649 18.3296C7.08515 18.1044 6.57891 18.0367 6.10184 18.2053L6.53496 19.431ZM2.89051 15.3631C2.95008 15.4804 2.95453 15.598 2.92245 15.6888L4.14818 16.1219C4.31026 15.6632 4.2539 15.1768 4.04966 14.7746L2.89051 15.3631Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.04492,
    cy: 11.0449,
    r: 1.125,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.5449,
    cy: 11.0449,
    r: 1.125,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.0449,
    cy: 11.0449,
    r: 1.125,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMemberMessage);
export default __webpack_public_path__ + "static/media/memberMessage.26031505ecc3a13b096482742b72e9ce.svg";
export { ForwardRef as ReactComponent };